/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetScopedCustomFieldValueRequestDto
 */
export interface CreateAssetScopedCustomFieldValueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetScopedCustomFieldValueRequestDto
     */
    assetCustomFieldId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetScopedCustomFieldValueRequestDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the CreateAssetScopedCustomFieldValueRequestDto interface.
 */
export function instanceOfCreateAssetScopedCustomFieldValueRequestDto(value: object): value is CreateAssetScopedCustomFieldValueRequestDto {
    if (!('assetCustomFieldId' in value) || value['assetCustomFieldId'] === undefined) return false;
    return true;
}

export function CreateAssetScopedCustomFieldValueRequestDtoFromJSON(json: any): CreateAssetScopedCustomFieldValueRequestDto {
    return CreateAssetScopedCustomFieldValueRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetScopedCustomFieldValueRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetScopedCustomFieldValueRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetCustomFieldId': json['assetCustomFieldId'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function CreateAssetScopedCustomFieldValueRequestDtoToJSON(json: any): CreateAssetScopedCustomFieldValueRequestDto {
    return CreateAssetScopedCustomFieldValueRequestDtoToJSONTyped(json, false);
}

export function CreateAssetScopedCustomFieldValueRequestDtoToJSONTyped(value?: CreateAssetScopedCustomFieldValueRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetCustomFieldId': value['assetCustomFieldId'],
        'value': value['value'],
    };
}

